export default "https://assets-v2.scaler.com/packs/files/Bolt.32ae38.lottie";